import { createEntityAdapter, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAdaptiveCardItem } from "../abstractions/IAdaptiveCards";
import { LoadingStates } from "@tdp/common/constants";

const cardEntityAdapter = createEntityAdapter<IAdaptiveCardItem, string>({
  selectId: (card) => card.id
});

const initialState = {
  loaded: false,
  cards: cardEntityAdapter.getInitialState(),
  isNewCardCreated: ""
}

export const adaptiveCardSlice = createSlice({
  name: "adaptiveCardSlice",
  initialState,
  reducers: {
    cardsLoaded: (state, action: PayloadAction<IAdaptiveCardItem[]>) => {
      state.loaded = true;
      cardEntityAdapter.upsertMany(state.cards, action.payload);
    },
    resetNewCard: (state) => {
      state.isNewCardCreated = "";
    },
    newCreatedSuccess: (state, action: PayloadAction<IAdaptiveCardItem>) => {
      state.isNewCardCreated = action.payload.id;
      cardEntityAdapter.addOne(state.cards, action.payload);
    },
    listItemDeleted: (state, action: PayloadAction<string>) => {
      cardEntityAdapter.removeOne(state.cards, action.payload);
    },
    cardUpdatedSuccess: (state, action: PayloadAction<IAdaptiveCardItem>) => {
      cardEntityAdapter.updateOne(state.cards, { id: action.payload.id, changes: action.payload });
    }
  },
  selectors: {
    loaded: (state) => state.loaded,
    cards: (state) => state.cards,
    isNewCardCreated: (state) => state.isNewCardCreated,
    getCardById: (state, id: string) => cardEntityAdapter.getSelectors().selectById(state.cards, id) as IAdaptiveCardItem | undefined,
  }
});